import { createFileRoute } from '@tanstack/react-router';
import SignupSuccessPage from '../pages/signup/SignupSuccessPage';

export const Route = createFileRoute('/signup_/success')({
  component: SignupSuccessPage,
  validateSearch: (search: Record<string, unknown>) => ({
    session_id: typeof search.session_id === 'string' ? search.session_id : undefined,
  }),
});
